export enum TeamViewMode {
  Add = 'add',
  Edit = 'edit',
  ViewDetails = 'viewDetails',
  ViewMembers = 'viewMembers',
}
